module.exports = __webpack_public_path__ + "img/1.04.1ec668bb.jpg";